// Определение языка кабинета. Порядок источников намеренно совпадает с тем, что
// делает лендинг (landings/<brand>/index.html, функция getLang): лендинг отдаётся
// на `/`, кабинет на `/partners/` — это ОДИН origin, поэтому localStorage у них
// общий и один ключ даёт сквозной язык «лендинг → кабинет» без всякой передачи
// параметров.
//
// Cookie NG_TRANSLATE_LANG_KEY читаем вторым источником: её ставил ещё
// AngularJS-кабинет (angular-translate), и партнёр, у которого выбор сохранён с
// тех времён, не должен потерять язык. Мы её при этом продолжаем писать —
// см. persist.ts: из неё берётся `lang-id` для запросов к API.

export const LANGUAGES = ['ru', 'en'] as const;

export type Lang = (typeof LANGUAGES)[number];

export const DEFAULT_LANG: Lang = 'ru';

// Общий с лендингом ключ. Менять нельзя, не поменяв его в обоих лендингах.
export const LANG_STORAGE_KEY = 'sp_lang';

export function isLang(value: unknown): value is Lang {
  return typeof value === 'string' && (LANGUAGES as readonly string[]).includes(value);
}

// localStorage бросает в приватном режиме и при запрете site data, поэтому
// каждое обращение — в try/catch (то же правило действует в persist.ts).
function readStorage(): string | null {
  try {
    return localStorage.getItem(LANG_STORAGE_KEY);
  } catch {
    return null;
  }
}

function readCookie(name: string): string | null {
  const prefix = `${name}=`;
  for (const part of document.cookie.split(';')) {
    const trimmed = part.trim();
    if (trimmed.startsWith(prefix)) {
      // Значение из angular-translate приезжает в кавычках ("ru") — снимаем.
      return decodeURIComponent(trimmed.slice(prefix.length)).replace(/"/g, '');
    }
  }
  return null;
}

// Язык браузера: та же логика, что на лендинге — всё, что начинается на ru,
// считаем русским, остальное английским. Промежуточных языков у нас нет.
function fromNavigator(): Lang {
  const nav = (navigator.language || '').toLowerCase();
  if (!nav) return DEFAULT_LANG;
  return nav.startsWith('ru') ? 'ru' : 'en';
}

export function detectLanguage(): Lang {
  const stored = readStorage();
  if (isLang(stored)) return stored;

  const cookie = readCookie('NG_TRANSLATE_LANG_KEY');
  if (isLang(cookie)) return cookie;

  return fromNavigator();
}
